<template>
  <div class="d-flex" id="wrapper">
    <div id="page-content-wrapper">
      <nav
        class="navbar navbar-expand-lg navbar-light bg-na-principal border-bottom fixed-top custom-navbar"
        :class="{ 'mobile-responsive': isMobile }"
      >
        <hamburger v-if="isMobile" />
        <div class="sidebar-heading">
          <router-link to="/">
            <img :src="logoImgUrl" alt="logo" class="logo" />
          </router-link>
        </div>
        <div class="float-right" id="navbarSupportedContent">
          <ul
            class="navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center pt-3 pt-md-0"
            :class="isMobile && 'ml-n4'"
          >
            <li
              class="nav-item b-nav-dropdown dropdown help-nav-ddl mr-2 mr-md-0"
            >
              <search-input @open-search="showSearch" />
            </li>
            <help-nav></help-nav>
            <!-- Opcion para mostrar Informacion del Usuario -->
            <custom-user-info
              class="custom-user-info"
              :row-elements="userCard.rowElements"
              :row-actions="userCard.rowActions"
              :last-login-date="userCard.lastLogin"
            />
          </ul>
        </div>
      </nav>
      <div class="d-none d-md-flex container-fluid student-container pr-0">
        <!-- <selected-student ref="SelectedStudent"
                           :student="selectedStudent"
                           v-if="hasStudentSelected"
          @DeselectedStudent="onDeselectedStudent" />-->
      </div>
      <search-input-mobile v-if="showSearchMobileInput" @close="closeSearch" />
    </div>

    <modal-password
      :show="showModalPassword"
      @on-close="showModalPassword = false"
      @submit="handleSubmitChangePassword"
    />

    <profile-info
      v-if="updateProfileVisible"
      :save-profile="updateMyProfile"
      :user="userInfo"
      value
      @close="updateProfileVisibleHandler"
    />
  </div>
</template>

<style scoped lang="scss">
.logo {
  width: 190px;
  height: 63px;
}

.alert-indicator {
  position: absolute;
  top: 32px;
  right: 157px;
  background: #fd3737 0% 0% no-repeat padding-box;
  color: #fff;
  width: 15px;
  height: 15px;
  opacity: 1;
  line-height: 15px;
  text-align: center;
  font-size: 10px;
}

.dropdown-menu-custom {
  top: 95% !important;
}

.custom-user-info {
  margin-right: 24px;
}

.custom-user-info ::v-deep > .user-panel > .dropdown-menu {
  margin-right: 11px;
  margin-top: -8px;
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .custom-user-info {
    margin-left: 1rem;
  }
}

@media screen and (max-width: 767px) {
  ul.navbar-nav {
    display: flex;
    flex-direction: row;
  }

  .custom-user-info {
    margin-left: 1rem;
  }

  .mobile-responsive > .sidebar-heading img {
    width: 100px !important;
    height: 37px !important;
    margin-top: unset;
  }

  .custom-navbar {
    height: 55px;
  }

  ::v-deep .avatar {
    width: 33px;
    height: 33px;
    font-size: 16px;
  }
}
</style>

<script>
import CustomUserInfo from 'CustomUserInfoPanel'
import HelpNav from './HelpNav'
import ModalPassword from '@quisit/mipe-modal-password'
import loading from '@quisit/mipe-utils/mixins/loading/index'
import { mapActions } from 'vuex'
import { name as userModuleName } from '@/modules/user/store/'
import { DASHBOARD_ROOT_NAV_MENU_ID } from '@/config.js'
import { ProfileInfo } from 'mipe-security'
import { updateMyProfile as _updateMyProfile } from '@/modules/user/api.js'
import { changepassword as _changepassword } from '@/modules/user/api.js'
import store from '@/modules/app/store/index'
import Hamburger from './Hamburger'
import SearchInput from './SearchInput'
import SearchInputMobile from './SearchInputMobile'

const KEY_PROFILE_UPDATED = 'profile-update-flag'

import logoUrl from "@/assets/logo.svg";
import logoTrainingUrl from "@/assets/logo-training.svg"

export default {
  components: {
    CustomUserInfo,
    HelpNav,
    ProfileInfo,
    ModalPassword,
    Hamburger,
    SearchInput,
    SearchInputMobile,
  },
  mixins: [loading],
  props: {
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedStudent: false,
      hasStudentSelected: false,
      updateProfileVisible: false,
      showModalPassword: false,
      showSearchMobileInput: false,
    }
  },
  computed: {
    isMobile() {
      return store.state.isMobileDensity
    },
    userCard() {
      return {
        rowElements: [
          {
            text: this.userInfo.role,
            icon: 'fas fa-key',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.name,
            icon: 'fas fa-user',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.email,
            icon: 'fas fa-envelope',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
        ],
        rowActions: [
          {
            text: 'Mi Perfil',
            icon: 'fas fa-address-card',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
          },
          {
            text: 'Cambiar Contraseña',
            icon: 'fas fa-repeat-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: () => {
              this.displayModalPassword()
            },
          },
          {
            text: 'Salir',
            icon: 'fas fa-sign-out-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: this.logout,
          },
        ],
        lastLogin: this.userInfo.lastLoginDate,
      }
    },
    logoImgUrl(){
      if(this.isTrainingEnv())
        return logoTrainingUrl;        
      return logoUrl;
    },
  },
  mounted() {
    this.updateProfileVisibleHandler()
  },
  methods: {
    ...mapActions(userModuleName, ['setMenuItemId']),
    async logout() {
      await this.$store.dispatch("$_user/logout");
    },
    goToDahsboardMenu() {
      this.setMenuItemId({ id: DASHBOARD_ROOT_NAV_MENU_ID })
      this.$router.push('/menu')
    },
    updateMyProfile(params) {
      return _updateMyProfile(params)
    },
    updateProfileVisibleHandler(value) {
      if (value != null) {
        sessionStorage.setItem(KEY_PROFILE_UPDATED, value)
      }
      this.updateProfileVisible =
        sessionStorage.getItem(KEY_PROFILE_UPDATED) === 'true'
    },
    displayModalPassword() {
      this.showModalPassword = true
    },
    async handleSubmitChangePassword(e) {
      this.ShowWait()
      let payload = {
        currentPassword: e.currentPassword,
        confirmPassword: e.confirmPassword,
        newPassword: e.newPassword,
      }
      let vm = this

      const { data } = await _changepassword(payload)
        .catch(function (error) {
          vm.ShowToast('Error', error.response.data.message, 'error')
        })
        .finally(() => {
          this.HideWait()
        })

      if (!data.error) {
        vm.showModalPassword = false

        vm.ShowToast(
          'Proceso Exitoso',
          'Su contraseña ha sido cambiada exitosamente.',
          'success'
        )

        vm.$router.go('/dashboard')

        return
      }
    },
    showSearch() {
      this.showSearchMobileInput = true
    },
    closeSearch() {
      this.showSearchMobileInput = false
    },
  },
}
</script>

